module.exports = __webpack_public_path__ + "static/media/pt_demo.c9b67ac5.svg";